import React from 'react';
import FieldA from '../../../../../dumb/Field/A';
import withState from '../../../../../../utils/withState';

module.exports = withState((setState, self) => {
  self.state = {};

  return (state, props) => {
    const {groupPlan} = props;
    const groupId = groupPlan.id;
    const niumAccountId = groupPlan.nium_account_id;
    const currency = groupPlan.currency;
    const amount = groupPlan.amount;
    const fee = groupPlan.fee;
    const exchange = groupPlan.exchange;

    return (
      <section>
        <h3>Group plan</h3>
        <div className="wmin830 mt20 cfx mh-10 (lt|w1/2|ph10)>1">
          <FieldA label="Group ID">{groupId}</FieldA>
          <FieldA label="Nium account ID">{niumAccountId}</FieldA>
          <FieldA label="Payout currency">{currency}</FieldA>
          <FieldA label="Payout amount">{amount}</FieldA>
          <FieldA label="Payout fee">{fee}</FieldA>
          <FieldA label="Exchange">{exchange}</FieldA>
        </div>
      </section>
    );
  };
});
